import ConfirmationModal from 'components/common/ConfirmationMessage';
import UrgentBadge from 'components/common/UrgentBadge';
import { PAGELENGTH } from 'components/common/ListLayout';
import { ListLayout } from 'components/common/ListLayout';
import TableHeaderItem from 'components/common/ListLayout/TableHeaderItem';
import { getEyeStyle } from 'components/common/TableColor';
import { getBackgroundStyle } from 'components/common/TableColor';
import { usePermissions } from 'layouts/Admin';
import moment from 'moment';
import { formatPostedAt } from 'utils/formatPostedAt';
import React, { useMemo } from 'react'
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useNavigation } from 'react-router-dom';
import { DashboardSelector } from 'slices/dashboardSlice';
import { dashboardSlice } from 'slices/dashboardSlice';
import { fetchDashboardAppointments } from 'slices/dashboardSlice';
// import { AcceptActionModal } from './AcceptActionModal';

const ListTable = ({ data, paginationParams, filterKey }) => {
    const dispatch = useDispatch();
    const { checkPermission } = usePermissions()
    const [addForm, setAddForm] = React.useState({
        show: false,
        item: {}
    });
    const refAddutton = React.useRef(null);

    const [selectedItems, setSelectedItems] = React.useState([]);
    const [selectAll, setSelectAll] = React.useState(false);
    const [declineModal, setDeclineModal] = React.useState(
        {
            show: false,
            item: {}
        }
    );
    const [selectedValue, setSelectedValue] = React.useState([10])
    const [currentPage, setCurrentPage] = React.useState(1);
    const [searchTerm, setSearchTerm] = React.useState("");
    const [sortConfig, setSortConfig] = React.useState({
        sortBy: 'datetime',
        sortDirection: 'asc',
    });;
    const [sortFields, setSortFields] = React.useState([]);

    const [actionAccept, setActionAccept] = React.useState({
        show: false,
        item: {}
    });
    const { dashboard, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(DashboardSelector);

    React.useEffect(() => {
        setSearchTerm("");
    }, [filterKey])

    const handleAddScheduleListPopUp = (item) => {
        setAddForm({
            show: true,
            item,
        });
    };

    const submitCallback = (status, message) => {
        if (status) {
            toast.success(message, {
                className: "successToast",
            })
            setSelectedItems([]);
            setSelectAll(false)
            // dispatch(fetchDashboardAppointments())
            hideConfirmDialog()
        }
        else {
            toast.error(message,
                {
                    className: "errorToast",
                }
            );
        }
    };

    const showConfirmDialog = () => {
        setDeclineModal(true);
        return
    };
    const hideConfirmDialog = () => {
        setDeclineModal(false);
    }

    const handleDeclineConfirm = () => {
        // dispatch(declineVendorJobs({ schedule_id: declineModal?.item?.id }, submitCallback))
    }


    const handleChange = (e) => {
        // handle form change
        const id = e.target.dataset.value
        setSelectedItems(
            selectedItems.includes(id) ?
                selectedItems.filter((item) => item != id) :
                [...selectedItems, id]
        )
    };

    // const viewItemButtonRef = React.useRef()



    //#region TABLE HEAD 

    const renderTableHeader = React.useCallback(() => {

        // const callBack = (direction, field, donotSort = false) => {
        //     setSortFields((prevConfigArray, nextConfig) => {
        //         let upgradedSortFields = [];
        //         const currentConfig = prevConfigArray.find(config => config.field === field)
        //         if (currentConfig) {
        //             upgradedSortFields = [...prevConfigArray.filter(config => config.field !== field), { field, direction }];
        //         }
        //         else {
        //             upgradedSortFields = [...prevConfigArray, { field, direction }]

        //         }
        //         // !donotSort && dispatch(fetchVendorPendingJobs(currentPage, { sortFields: JSON.stringify(upgradedSortFields), search: searchTerm }))
        //         return upgradedSortFields;
        //     });

        // }

        // const sortDirection = (field) => {
        //     const index = sortFields?.findIndex(config => config.field === field)
        //     if (index > -1) {
        //         const direction = sortFields[index].direction;
        //         return direction
        //     }
        //     return "asc"

        // }

        const callBack = (dir, sortBy) => {
            setSortConfig({ sortBy, sortDirection: dir })
            dispatch(fetchDashboardAppointments(1, { sortBy: sortBy, sortDirection: dir, search: searchTerm, pageLength, ...paginationParams }))
        }


        return (
            <tr>
                <th>#</th>
                <th>
                    <TableHeaderItem
                        title="appid"
                        sortBy="appid"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th>
                    <TableHeaderItem
                        title="Status"
                        sortBy="status"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th>
                    <TableHeaderItem
                        title="Meeting Date & Time"
                        sortBy="datetime"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Posted"
                        sortBy="created_at"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Department"
                        sortBy="department_id"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>Address</th>
                <th>
                    <TableHeaderItem
                        title="Language"
                        sortBy="language_id"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th>
                    <TableHeaderItem
                        title="Vendor"
                        sortBy="vendor_id"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
            </tr>
        )
    }, [selectAll, searchTerm, sortFields, currentPage, sortConfig, selectedItems, paginationParams, pageLength]);

    //#endregion


    //#region TABLE BODY

    const renderTableContent = React.useCallback(() => {
        return (
            data?.map((item, index) => (
                <AppointmentListItem item={item} index={index} handleAcceptButton={handleAcceptButton} handleDeclineShow={handleDeclineShow} current_page={current_page} pageLength={pageLength} checkPermission={checkPermission} />
            ))
        )
    }, [selectedItems, data]);

    //#endregion


    const handleAcceptButton = React.useCallback((id) => {
        // viewItemButtonRef.current?.click()
        setActionAccept({
            show: true,
            item: { id },
        });

    }, [])


    const handleCloseActionButton = React.useCallback((id) => {
        // viewItemButtonRef?.current?.click()
        setActionAccept({
            show: false,
            item: {}
        })
    }, [])



    const handleDeclineShow = React.useCallback((id) => {
        // viewItemButtonRef.current?.click()
        setDeclineModal({
            show: true,
            item: { id },
        });

    }, [])


    return (
        <div className='mt-4'>

            <ListLayout
                heading={`dashboard appointments`}
                time={false}
                fullMainHead={'ms-3'}
                title=""
                renderTableHeader={renderTableHeader}
                renderTableContent={renderTableContent}
                fetchList={fetchDashboardAppointments}
                initialPageLength={100}
                selectedItems={selectedItems}
                handleDeclineConfirm={handleDeclineConfirm}
                refAddutton={refAddutton}
                addForm={addForm}
                showConfirmDialog={showConfirmDialog}
                handleAddPopUp={handleAddScheduleListPopUp}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                searchPlaceholder="Search in this table ..."
                addButtonDisabled={true}
                totalPages={totalPages}
                sortConfig={sortConfig}
                noOfItems={total}
                paginationParams={paginationParams}
                filterKey={filterKey}
                apiCurrentPage={current_page}
            // loader={loader}


            >

                {/* <button
                    type='button'
                    hidden
                    ref={viewItemButtonRef} data-bs-toggle="modal" data-bs-target="#viewModal" className='display-none'
                /> */}
                {/* <AcceptActionModal item={actionAccept?.item} onClose={handleCloseActionButton} isOpen={actionAccept.show}/> */}

                {declineModal.show && <ConfirmationModal onClose={hideConfirmDialog} isOpen={declineModal?.show} onConfirm={handleDeclineConfirm} confirmationText="Are you sure you want to Decline?" />}

            </ListLayout>
        </div>
    )
}


const AppointmentListItem = React.memo(({
    item, index, handleAcceptButton, handleDeclineShow, current_page, pageLength, checkPermission

}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const serial = useMemo(() => {
        return index + 1 + (current_page - 1) * pageLength;
    }, [current_page, pageLength]);

    console.log(item, 'iteitemitemm')

    return (
        <tr>
            <td className='p-0' style={getBackgroundStyle(item?.status)}>
                <div className={`eye_area  ${item?.appointment_details?.extra_mileage_request == 1 && 'extra-mileage'}`} style={getEyeStyle(item?.status)}>
                    <Link to={`/appointments/view/${item?.id}`}><i class="fa-solid fa-eye"></i></Link>
                </div>
            </td>
            <td style={getBackgroundStyle(item?.status)}>
                {item?.appid || 'N/A'}
                {item?.is_urgent_effective && (
                    <div style={{ marginTop: 2 }}><UrgentBadge item={item} /></div>
                )}
            </td>
            <td style={getBackgroundStyle(item?.status)} className='text-transform-capitalize '>
                {item?.status?.replace(/_/g, ' ') || 'N/A'}
            </td>
            <td style={getBackgroundStyle(item?.status)}>
                {moment(item?.datetime).format("MMM D, YYYY HH:mm:ss") || 'N/A'}
            </td>
            <td style={getBackgroundStyle(item?.status)}>
                {formatPostedAt(item?.created_at)}
            </td>
            <td style={getBackgroundStyle(item?.status)}>
                {item?.appointment_details?.department?.name || 'N/A'}
            </td>
            <td style={{ ...getBackgroundStyle(item?.status), whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: '200px' }}>
                {item?.appointment_details?.address || item?.appointment_details?.department?.address || 'N/A'}
            </td>
            <td style={getBackgroundStyle(item?.status)}>
                {item?.language?.name || item?.other_language || 'N/A'}
            </td>
            <td style={{ ...getBackgroundStyle(item?.status), maxWidth: '200px', lineHeight: '20px' }}>
                {item?.vendor?.name} {(item?.interpreter_id) && ` - ${item?.interpreter?.first_name} ${item?.interpreter?.last_name || ''}`}
            </td>

        </tr>
    )
})
export default ListTable